import { render, staticRenderFns } from "./itemNonInventory.vue?vue&type=template&id=1b34f024&scoped=true&"
import script from "./itemNonInventory.vue?vue&type=script&lang=js&"
export * from "./itemNonInventory.vue?vue&type=script&lang=js&"
import style0 from "./itemNonInventory.vue?vue&type=style&index=0&id=1b34f024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34f024",
  null
  
)

export default component.exports